// extracted by mini-css-extract-plugin
export default {"wrapper":"Hire_wrapper__3MmfU","title":"Hire_title__mI+DB"};